import styled from "styled-components";
import { BORDER_RADIUS, COLORS, DEVICE_TYPE, SIZE } from "constants/variables";

export const Backdrop = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.RaisinBlack}A6;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  display: ${(props) => (props.open ? "flex" : "none")};
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  row-gap: ${SIZE.max24};
  z-index: 1001;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    overflow-y: scroll;
    position: absolute;
    bottom: 0;
  }
`;

export const ModalContent = styled.div<{ open: boolean }>`
  background-color: ${COLORS.RaisinBlack};
  z-index: 1001;
  border-radius: ${BORDER_RADIUS.radius24};
`;

export const ModalCloseButtonWrapper = styled.div`
  cursor: pointer;
  background-color: ${COLORS.RaisinBlack};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  aspect-ratio: 1/1;
  border-radius: ${BORDER_RADIUS.radius16};
`;

export const ModalCloseButton = styled.img`
  height: 30px;
  width: 30px;
`;
